import { render } from "./HonoreeFormOverviewPage.vue?vue&type=template&id=6b006cd3"
import script from "./HonoreeFormOverviewPage.vue?vue&type=script&lang=js"
export * from "./HonoreeFormOverviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__